import { forwardRef } from "react";
import { Skeleton } from "antd";
import { Flex } from "common/components/flex/flex";
import cn from "classnames";
import * as styles from "./metricItem.module.scss";

const MetricItemValue = ({ children, underline = false }) => (
  <span
    className={cn(
      "text-primary-accent",
      "font-weight-heavy",
      styles.metricIconValue,
      { [styles.metricIconValue_underline]: underline },
    )}
  >
    {children}
  </span>
);

const MetricItemSkeleton = ({
  className,
  style,
  labelHeight = 14,
  valueHeight = 28,
}) => (
  <Flex gap={8} className={`${styles.skeleton} ${className}`} style={style}>
    <Skeleton.Avatar
      active
      size="small"
      shape="square"
      style={{ width: 32, height: 32 }}
    />
    <Flex
      direction="column"
      gap={8}
      className={styles.skeleton__metricsContent}
    >
      <Skeleton.Input
        active
        size="small"
        style={{ width: "100%", height: labelHeight }}
      />
      <Skeleton.Input
        active
        size="small"
        style={{ width: "100%", height: valueHeight }}
      />
    </Flex>
  </Flex>
);

export const MetricItem = forwardRef(
  ({ label, icon, className, style, children, ...rest }, ref) => {
    return (
      <Flex gap={8} className={className} style={style} ref={ref} {...rest}>
        {icon}
        <Flex direction="column" align="flex-start" gap={8}>
          <span className="font-weight-medium">{label}</span>
          {children}
        </Flex>
      </Flex>
    );
  },
);

MetricItem.Value = MetricItemValue;
MetricItem.Skeleton = MetricItemSkeleton;
